import type { Dispatch } from "@reduxjs/toolkit";
import { WorkOrdersSummaryTable } from "../../ticket/WorkOrdersSummaryTable";
import type { ClientViewRenderProps } from "./ClientViewRender";
import { Card } from "../../../common/components/Card";

type TicketsInfoProps = ClientViewRenderProps & { dispatch: Dispatch };

export const TicketsInfo = ({ intl, clientData, dispatch }: TicketsInfoProps) => {
  const { tickets, ticketSideload, serviceObjects } = clientData;

  return (
    <Card title={intl.formatMessage({ id: "work_orders" })}>
      <WorkOrdersSummaryTable
        intl={intl}
        dispatch={dispatch}
        tickets={Object.values(tickets.results.tickets)}
        ticketSideload={ticketSideload}
        serviceObjects={serviceObjects}
      />
    </Card>
  );
};
